<template>
  <div class="d-flex flex-column mb-5">
    <div class="d-flex flex-column">
      <v-card class="d-flex mb-10 pa-5 align-center" v-for="(n, i) in selected.techs">
        <v-checkbox
          v-model="n.core"
          label="Pro?"
          hide-details
          class="ma-0 mr-1"
        ></v-checkbox>
        <v-autocomplete
          v-model="n.name"
          label="Technology"
          outlined
          dense
          hide-details
          class="mr-1"
          :items="techs"
        ></v-autocomplete>
        <v-text-field
          v-model="n.years"
          label="Years"
          outlined
          dense
          hide-details
          class="mr-1"
        ></v-text-field>
        
        <v-btn @click="selected.techs = selected.techs.filter((n, z_i) => z_i !== i)" fab small color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn depressed @click="selected.techs.push({ name: '', years: 1, core: false })" color="primary">
          add
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      techs: require('@/assets/techs').default,
    }
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style>
</style>